var map = {
	"./1J.svg": [
		1275,
		1275
	],
	"./2B.svg": [
		234,
		234
	],
	"./2C.svg": [
		6955,
		6955
	],
	"./2D.svg": [
		836,
		836
	],
	"./2H.svg": [
		6928,
		6928
	],
	"./2J.svg": [
		9330,
		9330
	],
	"./2S.svg": [
		2283,
		2283
	],
	"./3C.svg": [
		8504,
		8504
	],
	"./3D.svg": [
		3431,
		3431
	],
	"./3H.svg": [
		2259,
		2259
	],
	"./3S.svg": [
		3176,
		3176
	],
	"./4C.svg": [
		8537,
		8537
	],
	"./4D.svg": [
		9094,
		9094
	],
	"./4H.svg": [
		6882,
		6882
	],
	"./4S.svg": [
		4361,
		4361
	],
	"./5C.svg": [
		1910,
		1910
	],
	"./5D.svg": [
		1945,
		1945
	],
	"./5H.svg": [
		3597,
		3597
	],
	"./5S.svg": [
		6678,
		6678
	],
	"./6C.svg": [
		1295,
		1295
	],
	"./6D.svg": [
		1920,
		1920
	],
	"./6H.svg": [
		8884,
		8884
	],
	"./6S.svg": [
		8703,
		8703
	],
	"./7C.svg": [
		7260,
		7260
	],
	"./7D.svg": [
		4915,
		4915
	],
	"./7H.svg": [
		5735,
		5735
	],
	"./7S.svg": [
		9852,
		9852
	],
	"./8C.svg": [
		3069,
		3069
	],
	"./8D.svg": [
		4546,
		4546
	],
	"./8H.svg": [
		4118,
		4118
	],
	"./8S.svg": [
		1037,
		1037
	],
	"./9C.svg": [
		3498,
		3498
	],
	"./9D.svg": [
		2597,
		2597
	],
	"./9H.svg": [
		3377,
		3377
	],
	"./9S.svg": [
		6298,
		6298
	],
	"./AC.svg": [
		4210,
		4210
	],
	"./AD.svg": [
		2733,
		2733
	],
	"./AH.svg": [
		3193,
		3193
	],
	"./AS.svg": [
		6770,
		6770
	],
	"./JC.svg": [
		4531,
		4531
	],
	"./JD.svg": [
		6252,
		6252
	],
	"./JH.svg": [
		6152,
		6152
	],
	"./JJ.svg": [
		9674,
		9674
	],
	"./JS.svg": [
		9235,
		9235
	],
	"./KC.svg": [
		8160,
		8160
	],
	"./KD.svg": [
		7535,
		7535
	],
	"./KH.svg": [
		3483,
		3483
	],
	"./KS.svg": [
		7472,
		7472
	],
	"./QC.svg": [
		7778,
		7778
	],
	"./QD.svg": [
		1709,
		1709
	],
	"./QH.svg": [
		9433,
		9433
	],
	"./QS.svg": [
		1922,
		1922
	],
	"./TC.svg": [
		105,
		105
	],
	"./TD.svg": [
		694,
		694
	],
	"./TH.svg": [
		1122,
		1122
	],
	"./TS.svg": [
		1785,
		1785
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6739;
module.exports = webpackAsyncContext;